import { Description } from '@/creditflowresearch/ui/common/components/CreditFlowResearch/CreditFlowData';
import StatsAttachment from './StatsAttachment';

import styles from './styles.module.scss';

const StatExpandedData = ({ rowData: { description, preview, attachment } }) => (
  <div
    className={ styles.expandedData }
    data-test="expandedData"
  >
    { description && (
    <Description
      description={ description }
      dataTest="statDescription"
      className={ styles.expandedDescription }
    />
      ) }
    { preview && (
    <div data-test="statImagePreview">
      <img
        src={ preview.url }
        alt="Stat preview"
      />
    </div>
      ) }
    { attachment && (
    <StatsAttachment attachment={ attachment } />
      ) }
  </div>
);

export default StatExpandedData;
